var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "dish-group-batch" },
    [
      _c("div", { staticClass: "page-header" }, [
        _vm._m(0),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "header-actions" },
          [
            _c(
              "el-button",
              {
                staticClass: "add-btn",
                attrs: { type: "primary", icon: "el-icon-plus" },
                on: { click: _vm.handleOpenAddDialog },
              },
              [_vm._v("添加商品")]
            ),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c(
            "el-row",
            { attrs: { gutter: 24 } },
            [
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "content-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("商品列表"),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "header-actions" },
                      [
                        _vm.selectedTableProducts.length > 0
                          ? _c(
                              "el-button",
                              {
                                staticClass: "batch-delete-btn",
                                attrs: { type: "text" },
                                on: { click: _vm.handleBatchRemove },
                              },
                              [
                                _c("i", { staticClass: "el-icon-delete" }),
                                _vm._v(
                                  "\n                批量删除(" +
                                    _vm._s(_vm.selectedTableProducts.length) +
                                    ")\n              "
                                ),
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", { staticClass: "card-count" }, [
                          _vm._v(
                            "共 " + _vm._s(_vm.tableData.length) + " 件商品"
                          ),
                        ]),
                      ],
                      1
                    ),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "div",
                        { staticClass: "list-search-section" },
                        [
                          _c("el-input", {
                            staticClass: "product-search-input",
                            attrs: {
                              placeholder: "搜索商品名称或编码...",
                              "prefix-icon": "el-icon-search",
                              clearable: "",
                            },
                            on: { input: _vm.handleProductSearch },
                            model: {
                              value: _vm.productSearch,
                              callback: function ($$v) {
                                _vm.productSearch = $$v
                              },
                              expression: "productSearch",
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-table",
                        {
                          ref: "productListTableRef",
                          staticClass: "apple-table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.filteredProductList,
                            "header-cell-style": _vm.headerCellStyle,
                            "max-height": "550px",
                          },
                          on: {
                            "selection-change": _vm.handleTableSelectionChange,
                          },
                        },
                        [
                          _c("el-table-column", {
                            attrs: {
                              type: "selection",
                              width: "55",
                              align: "center",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goodsId",
                              label: "商品ID",
                              width: "90",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("span", { staticClass: "id-tag" }, [
                                      _vm._v("#" + _vm._s(scope.row.goodsId)),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goodsName",
                              label: "商品名称",
                              "min-width": "130",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c("div", { staticClass: "product-info" }, [
                                      _c(
                                        "div",
                                        { staticClass: "product-name" },
                                        [_vm._v(_vm._s(scope.row.goodsName))]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "product-category" },
                                        [_vm._v(_vm._s(scope.row.goodsCode))]
                                      ),
                                    ]),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "所属分组",
                              "min-width": "150",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    scope.row.groups &&
                                    scope.row.groups.length > 0
                                      ? _c(
                                          "div",
                                          { staticClass: "groups-container" },
                                          _vm._l(
                                            scope.row.groups,
                                            function (group, index) {
                                              return _c(
                                                "el-tag",
                                                {
                                                  key: index,
                                                  attrs: {
                                                    size: "mini",
                                                    type: "info",
                                                  },
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                      " +
                                                      _vm._s(group.groupName) +
                                                      "\n                    "
                                                  ),
                                                ]
                                              )
                                            }
                                          ),
                                          1
                                        )
                                      : _c(
                                          "span",
                                          {
                                            staticStyle: {
                                              color: "#909399",
                                              "font-size": "12px",
                                            },
                                          },
                                          [_vm._v("未分组")]
                                        ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "goodsThumbnailUrl",
                              label: "商品图片",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "div",
                                      { staticClass: "product-image" },
                                      [
                                        _c("img", {
                                          attrs: {
                                            src: scope.row.goodsThumbnailUrl,
                                            alt: "商品图片",
                                          },
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              label: "操作",
                              width: "80",
                              align: "center",
                            },
                            scopedSlots: _vm._u([
                              {
                                key: "default",
                                fn: function (scope) {
                                  return [
                                    _c(
                                      "el-button",
                                      {
                                        staticClass: "remove-btn",
                                        attrs: { type: "text" },
                                        on: {
                                          click: function ($event) {
                                            return _vm.handleRemove(scope.row)
                                          },
                                        },
                                      },
                                      [
                                        _c("i", {
                                          staticClass: "el-icon-delete",
                                        }),
                                      ]
                                    ),
                                  ]
                                },
                              },
                            ]),
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
              ]),
              _vm._v(" "),
              _c("el-col", { attrs: { span: 12 } }, [
                _c("div", { staticClass: "content-card" }, [
                  _c("div", { staticClass: "card-header" }, [
                    _c("span", { staticClass: "card-title" }, [
                      _vm._v("批量操作"),
                    ]),
                  ]),
                  _vm._v(" "),
                  _c(
                    "div",
                    { staticClass: "card-body" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "formRef",
                          staticClass: "apple-form",
                          attrs: {
                            model: _vm.form,
                            "label-position": "top",
                            "label-width": "auto",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { label: "选择操作类型" } },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  staticClass: "operation-radio",
                                  model: {
                                    value: _vm.form.operation,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.form, "operation", $$v)
                                    },
                                    expression: "form.operation",
                                  },
                                },
                                [
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "add" } },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-folder-add",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("批量添加分组")]),
                                    ]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "el-radio-button",
                                    { attrs: { label: "clear" } },
                                    [
                                      _c("i", {
                                        staticClass: "el-icon-delete",
                                      }),
                                      _vm._v(" "),
                                      _c("span", [_vm._v("批量清除分组")]),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.form.operation
                            ? _c(
                                "el-form-item",
                                { attrs: { label: "选择分组" } },
                                [
                                  _vm.form.operation === "add"
                                    ? _c(
                                        "div",
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticClass: "group-select",
                                              staticStyle: { width: "100%" },
                                              attrs: {
                                                placeholder:
                                                  "请选择分组（可多选）",
                                                filterable: "",
                                                multiple: "",
                                                clearable: "",
                                              },
                                              model: {
                                                value: _vm.form.groupIds,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.form,
                                                    "groupIds",
                                                    $$v
                                                  )
                                                },
                                                expression: "form.groupIds",
                                              },
                                            },
                                            _vm._l(
                                              _vm.groupOptions,
                                              function (item) {
                                                return _c(
                                                  "el-option",
                                                  {
                                                    key: item.id,
                                                    attrs: {
                                                      label: item.name,
                                                      value: item.id,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          float: "left",
                                                          "font-weight": "500",
                                                        },
                                                      },
                                                      [
                                                        _vm._v(
                                                          _vm._s(item.name)
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "div",
                                                      {
                                                        staticStyle: {
                                                          float: "right",
                                                          color: "#8492a6",
                                                          "font-size": "12px",
                                                          "max-width": "200px",
                                                          overflow: "hidden",
                                                          "text-overflow":
                                                            "ellipsis",
                                                          "white-space":
                                                            "nowrap",
                                                        },
                                                      },
                                                      [
                                                        item.subtitle
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.subtitle
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.subtitle &&
                                                        item.regionCategory
                                                          ? _c("span", [
                                                              _vm._v(" | "),
                                                            ])
                                                          : _vm._e(),
                                                        _vm._v(" "),
                                                        item.regionCategory
                                                          ? _c("span", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.regionCategory
                                                                )
                                                              ),
                                                            ])
                                                          : _vm._e(),
                                                      ]
                                                    ),
                                                  ]
                                                )
                                              }
                                            ),
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            { staticClass: "form-tip" },
                                            [
                                              _vm._v(
                                                "提示：将选中的商品批量添加到所选分组中，如果商品已存在则跳过"
                                              ),
                                            ]
                                          ),
                                        ],
                                        1
                                      )
                                    : _vm.form.operation === "clear"
                                    ? _c("div", [
                                        _vm.tableData.length > 0
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "groups-clear-container",
                                              },
                                              _vm._l(
                                                _vm.tableData,
                                                function (item, index) {
                                                  return _c(
                                                    "div",
                                                    {
                                                      key: item.goodsId,
                                                      staticClass:
                                                        "goods-group-item",
                                                    },
                                                    [
                                                      _c(
                                                        "div",
                                                        {
                                                          staticClass:
                                                            "goods-name",
                                                        },
                                                        [
                                                          _vm._v(
                                                            "商品: " +
                                                              _vm._s(
                                                                item.goodsName
                                                              )
                                                          ),
                                                        ]
                                                      ),
                                                      _vm._v(" "),
                                                      item.groups &&
                                                      item.groups.length > 0
                                                        ? _c(
                                                            "div",
                                                            [
                                                              _c(
                                                                "el-checkbox-group",
                                                                {
                                                                  staticClass:
                                                                    "group-checkbox-group",
                                                                  on: {
                                                                    change:
                                                                      _vm.handleSelectionChange,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      item.selectedGroups,
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          item,
                                                                          "selectedGroups",
                                                                          $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "item.selectedGroups",
                                                                  },
                                                                },
                                                                _vm._l(
                                                                  item.groups,
                                                                  function (
                                                                    group
                                                                  ) {
                                                                    return _c(
                                                                      "el-checkbox",
                                                                      {
                                                                        key: group.groupId,
                                                                        staticClass:
                                                                          "group-checkbox",
                                                                        attrs: {
                                                                          label:
                                                                            group.groupId,
                                                                        },
                                                                      },
                                                                      [
                                                                        _c(
                                                                          "span",
                                                                          {
                                                                            staticClass:
                                                                              "group-name",
                                                                          },
                                                                          [
                                                                            _vm._v(
                                                                              _vm._s(
                                                                                group.groupName
                                                                              )
                                                                            ),
                                                                          ]
                                                                        ),
                                                                        _vm._v(
                                                                          " "
                                                                        ),
                                                                        group.subtitle
                                                                          ? _c(
                                                                              "span",
                                                                              {
                                                                                staticClass:
                                                                                  "group-subtitle",
                                                                              },
                                                                              [
                                                                                _vm._v(
                                                                                  _vm._s(
                                                                                    group.subtitle
                                                                                  )
                                                                                ),
                                                                              ]
                                                                            )
                                                                          : _vm._e(),
                                                                      ]
                                                                    )
                                                                  }
                                                                ),
                                                                1
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        : _c(
                                                            "div",
                                                            {
                                                              staticClass:
                                                                "no-groups-tip",
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticStyle: {
                                                                    color:
                                                                      "#909399",
                                                                    "font-size":
                                                                      "12px",
                                                                  },
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "该商品未分组"
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          ),
                                                    ]
                                                  )
                                                }
                                              ),
                                              0
                                            )
                                          : _c(
                                              "div",
                                              { staticClass: "form-tip" },
                                              [
                                                _vm._v(
                                                  "\n                    请先在左侧添加商品\n                  "
                                                ),
                                              ]
                                            ),
                                      ])
                                    : _vm._e(),
                                ]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "action-footer" },
                  [
                    _c(
                      "el-button",
                      {
                        staticClass: "cancel-btn",
                        on: { click: _vm.handleCancel },
                      },
                      [_vm._v("取消")]
                    ),
                    _vm._v(" "),
                    _c(
                      "el-button",
                      {
                        staticClass: "submit-btn",
                        attrs: {
                          type: "primary",
                          loading: _vm.submitting,
                          disabled: !_vm.canSubmit,
                        },
                        on: { click: _vm.handleSubmit },
                      },
                      [
                        _vm._v(
                          "\n            确认" +
                            _vm._s(
                              _vm.form.operation === "add" ? "添加" : "清除"
                            ) +
                            "\n          "
                        ),
                      ]
                    ),
                  ],
                  1
                ),
              ]),
            ],
            1
          ),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-dialog",
        {
          staticClass: "add-product-dialog",
          attrs: {
            title: "添加商品",
            visible: _vm.addDialogVisible,
            width: "900px",
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.addDialogVisible = $event
            },
          },
        },
        [
          _c("div", { staticClass: "dialog-content" }, [
            _c(
              "div",
              { staticClass: "search-section" },
              [
                _c("el-input", {
                  staticClass: "product-search",
                  attrs: {
                    placeholder: "搜索商品名称或ID...",
                    "prefix-icon": "el-icon-search",
                    clearable: "",
                  },
                  on: { input: _vm.handleAddProductSearch },
                  model: {
                    value: _vm.addProductSearch,
                    callback: function ($$v) {
                      _vm.addProductSearch = $$v
                    },
                    expression: "addProductSearch",
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "product-list-container" },
              [
                _c(
                  "el-table",
                  {
                    directives: [
                      {
                        name: "loading",
                        rawName: "v-loading",
                        value: _vm.addLoading,
                        expression: "addLoading",
                      },
                    ],
                    ref: "addProductTableRef",
                    staticClass: "product-select-table",
                    staticStyle: { width: "100%" },
                    attrs: {
                      data: _vm.addFilteredProductList,
                      "header-cell-style": _vm.headerCellStyle,
                      "max-height": "400px",
                    },
                    on: { "selection-change": _vm.handleAddSelectionChange },
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        type: "selection",
                        width: "55",
                        align: "center",
                      },
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: { prop: "id", label: "商品ID", width: "90" },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("span", { staticClass: "id-tag" }, [
                                _vm._v("#" + _vm._s(scope.row.id)),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodsName",
                        label: "商品名称",
                        "min-width": "120",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c("div", { staticClass: "product-info" }, [
                                _c("div", { staticClass: "product-name" }, [
                                  _vm._v(_vm._s(scope.row.goodsName)),
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "product-category" }, [
                                  _vm._v(_vm._s(scope.row.goodsCode)),
                                ]),
                              ]),
                            ]
                          },
                        },
                      ]),
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        prop: "goodsThumbnailUrl",
                        label: "商品图片",
                        width: "80",
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function (scope) {
                            return [
                              _c(
                                "div",
                                { staticClass: "product-image-small" },
                                [
                                  _c("img", {
                                    attrs: {
                                      src: scope.row.goodsThumbnailUrl,
                                      alt: "商品图片",
                                    },
                                  }),
                                ]
                              ),
                            ]
                          },
                        },
                      ]),
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c("el-button", { on: { click: _vm.handleCloseAddDialog } }, [
                _vm._v("取消"),
              ]),
              _vm._v(" "),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "primary",
                    disabled: _vm.selectedAddProducts.length === 0,
                  },
                  on: { click: _vm.handleConfirmAdd },
                },
                [_vm._v("\n        确认添加\n      ")]
              ),
            ],
            1
          ),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "header-content" }, [
      _c("h1", { staticClass: "page-title" }, [_vm._v("菜品分组批量操作")]),
      _vm._v(" "),
      _c("p", { staticClass: "page-subtitle" }, [
        _vm._v("批量管理菜品分组关系"),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }